import {
  makeColorSchema
} from "./chunk-SNUDSNGS.js";
import "./chunk-EUXUH3YW.js";

// libs/core/src/lib/theme/themes/brand-color-schemes/violet.style.ts
var violetStyle = makeColorSchema("#2f8af5");
export {
  violetStyle
};
//# sourceMappingURL=violet.style-Y3WLLZZ6.js.map
